function isSmartPhone() {
  if (window.matchMedia && window.matchMedia('(max-device-width: 640px)').matches) {
    // for SP
    btnScrollVisbility()

  } else {
    // for PC
    btnVisibility();
  }
}
isSmartPhone()

// used for PC
function btnVisibility() {
  window.addEventListener('DOMContentLoaded', function () {
    const fixBtnElement = document.getElementById("fix-button");
    fixBtnElement.setAttribute("style", "visibility:visible;");
    if (fixBtnElement === true) {
      if (projectsPageTitle.textContent === 'Projects') {
        fixBtnElement.setAttribute('style', 'right:32px;');
      }

    }
  })
}

// used for SP
function btnScrollVisbility() {
  window.addEventListener("DOMContentLoaded", function () {
    const fixBtnElement = document.getElementById("fix-button");
    const fixBtnElementImg = document.querySelector(".fix-button a img");
    fixBtnElement.setAttribute("style", "visibility:hidden;");
    // fixBtnElement.setAttribute("style", "opacity:0;");

    document.addEventListener("scroll", function () {
      const scrollY = window.pageYOffset;
      if (scrollY > 800) {
        // fixBtnElement.classList.add("visibilityActive");
        // fixBtnElement.setAttribute("style", "opacity:1;");
        fixBtnElement.setAttribute("style", "visibility:visible;");
        fixBtnElementImg.setAttribute("width", "70px");
        fixBtnElementImg.setAttribute("height", "70px");
        if (projectsPageTitle?.textContent === 'Projects') {
          fixBtnElement.setAttribute('style', 'right:32px;');
        }
      } else {
        // fixBtnElement.setAttribute("style", "opacity:0;");
        fixBtnElement.setAttribute("style", "visibility:hidden;");
        // fixBtnElement.classList.remove("visibilityActive")
      }
    });
  });
}

// contact page accordion script
const faqs = document.querySelectorAll('.faqs');

faqs.forEach((faq) => {
  faq.addEventListener('click', () => {
    faq.classList.toggle('active');
  })
})

// メガメニュー内の要素を左から順に表示するアニメーション
document.addEventListener('DOMContentLoaded', () => {
  // メガメニューの開閉を監視
  document.querySelectorAll('.site-nav--has-dropdown').forEach(dropdown => {
    dropdown.addEventListener('mouseenter', () => {
      // メニューが開いたときに、少し遅延させてから要素を順番に表示
      setTimeout(() => {
        const menuItems = dropdown.querySelectorAll('.mega-menu-item');
        menuItems.forEach((item, index) => {
          // 各要素を少しずつ遅延させて表示
          setTimeout(() => {
            item.classList.add('visible');
          }, 100 * index); // 各要素に100msの遅延を追加
        });
      }, 300); // メニューが開いてから300ms後に開始
    });
    
    dropdown.addEventListener('mouseleave', () => {
      // メニューが閉じたら、すべての要素を非表示状態にリセット
      const menuItems = dropdown.querySelectorAll('.mega-menu-item');
      menuItems.forEach(item => {
        item.classList.remove('visible');
      });
    });
  });
});
